import React from "react";
import PropTypes from "prop-types";

export default function Trash(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      style={props.style}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.673171 2.10648H4.36102V0.684796C4.36102 0.306632 4.66245 0 5.03428 0H9.96564C10.3374 0 10.6389 0.306591 10.6389 0.684796V2.10648H14.3267C14.6985 2.10648 15 2.41307 15 2.79127V4.89771C15 5.27587 14.6986 5.5825 14.3267 5.5825H0.673253C0.301463 5.5825 0 5.27591 0 4.89771V2.79127C-4.00543e-05 2.41303 0.301382 2.10648 0.673171 2.10648ZM5.70757 2.10648H9.29239V1.36955H5.70757V2.10648Z"
        fill={props?.fill ? props.fill : "#E49C9C"}
      />
      <path
        d="M14.0651 6.95201L13.5068 20.3442C13.4916 20.7108 13.1949 21 12.8342 21H2.16573C1.80503 21 1.50837 20.7108 1.49313 20.3442L0.934916 6.95201H14.0651ZM9.53514 18.2152C9.53514 18.5934 9.83657 18.9 10.2084 18.9C10.5802 18.9 10.8816 18.5934 10.8816 18.2152V9.73672C10.8816 9.35856 10.5802 9.05193 10.2084 9.05193C9.83661 9.05193 9.53514 9.35852 9.53514 9.73672V18.2152ZM6.82685 18.2152C6.82685 18.5934 7.12827 18.9 7.5001 18.9C7.87193 18.9 8.17335 18.5934 8.17335 18.2152V9.73672C8.17335 9.35856 7.87193 9.05193 7.5001 9.05193C7.12827 9.05193 6.82685 9.35852 6.82685 9.73672V18.2152ZM4.11855 18.2152C4.11855 18.5934 4.41998 18.9 4.79181 18.9C5.16364 18.9 5.46506 18.5934 5.46506 18.2152V9.73672C5.46506 9.35856 5.16364 9.05193 4.79181 9.05193C4.41998 9.05193 4.11855 9.35852 4.11855 9.73672V18.2152Z"
        fill={props?.fill ? props.fill : "#E49C9C"}
      />
    </svg>
  );
}

Trash.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  style: PropTypes.shape({})
};

Trash.defaultProps = {
  className: "",
  width: 168,
  height: 168,
  fill: "#E49C9C",
  style: {}
};
